import axios from 'axios';

const fetchRates = async (body,type = 'point') => {
    const url = `${process.env.REACT_APP_BACKEND_ENDPOINT}rates`;
    const token = `${(type === 'point') ? process.env.REACT_APP_PARCEL_POINT_API_KEY : process.env.REACT_APP_KIOSK_API_KEY}`;

    try {
        const response = await axios.post(url, body, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        return response.data; 
    } catch (error) {
        throw error.response ? error.response.data : error.message;
    }
}

export default fetchRates